package com.sddamico.pages

import androidx.compose.runtime.*
import com.sddamico.HeadingFontFamily
import com.sddamico.SitePalette
import com.sddamico.api.ApiException
import com.sddamico.api.apiGet
import com.sddamico.components.layouts.PageLayoutData
import com.sddamico.components.widgets.EmptyState
import com.sddamico.components.widgets.ErrorCard
import com.sddamico.components.widgets.PageLoading
import com.sddamico.components.widgets.MoveCard
import com.sddamico.components.widgets.PickTradeCard
import com.sddamico.components.widgets.TradeCard
import com.sddamico.models.TransactionListResponse
import com.sddamico.models.TransactionResponse
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.jetbrains.compose.web.css.*

@InitRoute
fun initTransactions(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Transactions"))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun TransactionsPage() {
    var transactions by remember { mutableStateOf<List<TransactionResponse>>(emptyList()) }
    var loading by remember { mutableStateOf(true) }
    var error by remember { mutableStateOf<String?>(null) }

    LaunchedEffect(Unit) {
        try {
            val resp = apiGet("/api/transactions/list", TransactionListResponse.serializer())
            transactions = resp.transactions
        } catch (e: ApiException) {
            error = e.errorMessage
        } catch (e: Exception) {
            error = "Failed to load transactions"
        }
        loading = false
    }

    if (loading) {
        PageLoading()
        return
    }

    if (error != null) {
        ErrorCard(error!!)
        return
    }

    if (transactions.isEmpty()) {
        EmptyState("No transactions yet")
        return
    }

    Column(Modifier.fillMaxWidth().gap(1.cssRem)) {
        SpanText(
            "Transactions",
            Modifier
                .fontFamily(*HeadingFontFamily)
                .fontSize(2.cssRem)
                .fontWeight(FontWeight.Bold)
                .color(SitePalette.text)
        )

        transactions.forEach { txn ->
            when (txn.type) {
                "ROSTER_MOVE" -> txn.rosterMove?.let { MoveCard(it) }
                "PICK_TRADE" -> txn.pickTrade?.let { PickTradeCard(it) }
                "TRADE" -> txn.tradeOffer?.let { TradeCard(it) }
            }
        }
    }
}
